module.exports = __webpack_public_path__ + "img/shield.67dab00e.svg";